import React from 'react';
import './IntegrationDocsPage.css';

// Code snippets for integration examples
const salesforceExample = `// npm install jsforce
const jsforce = require('jsforce');
const conn = new jsforce.Connection({ loginUrl: 'https://login.salesforce.com' });
conn.login('username@example.com', 'passwordTOKEN', (err) => {
  if (err) return console.error(err);
  conn.sobject('Task').create({
    Subject: 'Call with Client',
    WhoId: '0031t00000XXXXX',
    Status: 'Completed'
  }, (err, ret) => {
    if (err || !ret.success) return console.error(err, ret);
    console.log('Task created:', ret.id);
  });
});`;

const hubspotExample = `# pip install hubspot-api-client
from hubspot import HubSpot
client = HubSpot(api_key='YOUR_API_KEY')
client.crm.contacts.basic_api.create(
  simple_public_object_input={'properties': {'firstname': 'Alice', 'lastname': 'Smith'}}
)`;

const zendeskExample = `curl -X POST https://yoursubdomain.zendesk.com/api/v2/tickets.json \
  -u user@example.com/token:ZENDESK_API_TOKEN \
  -H 'Content-Type: application/json' \
  -d '{"ticket": {"subject": "Missed call from +15551234567", "comment": {"body": "Call details here"}}}'`;

const servicenowExample = `POST https://instance.service-now.com/api/now/table/incident
Headers:
  Authorization: Basic BASE64(user:pass)
Body:
{
  "short_description": "VoIP call failed",
  "description": "Error code 502 during outbound call",
  "caller_id": "Bob"
}`;

export default function IntegrationDocsPage() {
  return (
    <div className="integration-docs-page">
      <section className="hero">
        <h1>Integration Guides</h1>
        <p>Connect VoicePro with your favorite CRM, helpdesk, and business systems effortlessly.</p>
      </section>
      <section className="integration-section" id="salesforce">
        <h2>Salesforce Connector</h2>
        <p>Automatically log call activity and create tasks in Salesforce.</p>
        <h3>Node.js Example</h3>
        <pre><code>{salesforceExample}</code></pre>
      </section>
      <section className="integration-section" id="hubspot">
        <h2>HubSpot Integration</h2>
        <p>Sync call logs and contact activity into HubSpot CRM.</p>
        <h3>Python Example</h3>
        <pre><code>{hubspotExample}</code></pre>
      </section>
      <section className="integration-section" id="zendesk">
        <h2>Zendesk Connector</h2>
        <p>Create support tickets automatically from call events in Zendesk.</p>
        <h3>cURL Example</h3>
        <pre><code>{zendeskExample}</code></pre>
      </section>
      <section className="integration-section" id="servicenow">
        <h2>ServiceNow Integration</h2>
        <p>Log incidents directly into ServiceNow from your call flows.</p>
        <h3>REST Example</h3>
        <pre><code>{servicenowExample}</code></pre>
      </section>
      <footer className="integration-footer">
        <p>For custom connectors or consulting, visit our <a href="/docs/api">API Documentation</a> or <a href="/support">Support Center</a>.</p>
      </footer>
    </div>
  );
}